import React, { useState, useEffect } from "react";
import { Input, message, Row, Col, Button, Form } from "antd";
import { Link, withRouter } from "react-router-dom";
import { extractParams } from "../../utils/utils";
import { reset } from "../../utils/auth";
import { verticalFormLayout } from "../../utils/forms";
import logoLS from "../../assets/logo/linksight-logo.svg";

const ResetPassword = (props) => {
  const [loading, setLoading] = useState(false);
  const [token, setToken] = useState("");
  const [errorDisplay, setErrorDisplay] = useState(false);
  const [successDisplay, setSuccessDisplay] = useState(false);
  const [errorMessage, setErrorMessage] = useState();

  useEffect(() => {
    const getParam = async () => {
      const param = await extractParams(props);
      setToken(param.id);
    };
    getParam();
    // eslint-disable-next-line
  }, []);

  const onFinish = async (values) => {
    try {
      if (token && values.password) {
        setLoading(true);
        const resetPass = await reset(token, values.password);
        if (resetPass.message === "Password successfully reset") {
          setSuccessDisplay(true);
          setLoading(false);
        } else {
          console.error(resetPass.err);
          setErrorDisplay(true);
          setErrorMessage(resetPass.err);
          setLoading(false);
        }
      } else {
        message.error("Please provide a valid password.");
      }
    } catch (err) {
      message.error(err.message);
    }
  };

  const onFinishFailed = () => {
    message.error("Une erreur est survenue");
  };
  return (
    <div className="signin-container">
      <Row>
        <Col xl={8} lg={8} md={24} sm={24} xs={24}>
          <div className="block-signin">
            <div className="heading-auth">
              <div className="logo-ls">
                <img src={logoLS} alt="logo linksight" width="190px" />
              </div>
              <span>Configurez votre nouveau mot de passe</span>
            </div>

            <div className="signin-local">
              {!errorDisplay && !successDisplay && (
                <>
                  <Form
                    {...verticalFormLayout}
                    layout="vertical"
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    // className="align-left"
                  >
                    <Form.Item
                      label="Mot de passe"
                      name="password"
                      rules={[
                        {
                          required: true,
                          message: "Insérez votre mot de passe",
                        },
                      ]}
                    >
                      <Input
                        className="auth-input"
                        placeholder="*********"
                        type="password"
                      />
                    </Form.Item>
                    <Form.Item>
                      <Button
                        className="signup-button"
                        type="secondary"
                        htmlType="submit"
                        loading={loading}
                        size="large"
                      >
                        Changer de mot de passe
                      </Button>
                    </Form.Item>
                  </Form>
                </>
              )}
              {successDisplay && (
                <>
                  <div className="success-reset">
                    <span
                      role="img"
                      aria-label="emoji"
                      style={{ marginRight: "10px" }}
                    >
                      ✅
                    </span>
                    <span>Mot de passe modifié avec succès !</span>
                    <br />
                    <span>
                      Vous pouvez désormais vous connecter à Linksight !
                    </span>
                  </div>
                  <Button
                    className="signup-button-valid"
                    type="primary"
                    disabled={loading}
                  >
                    <Link to="/signin">Se connecter</Link>
                  </Button>
                </>
              )}
              {errorDisplay && (
                <>
                  <div className="success-reset">
                    <span role="img" aria-label="emoji">
                      ❌{" "}
                    </span>
                    Oh-ho! {errorMessage}
                    <span>
                      <br />
                      Quelque chose ne s'est pas passé comme prévu. <br />
                      <br />
                      Contacter notre équipe pour résoudre le problème.
                    </span>
                  </div>
                  <Button
                    className="signup-button-valid"
                    type="primary"
                    disabled={loading}
                  >
                    <Link to="/forgot-password"> Recevoir un nouveau lien</Link>
                  </Button>
                </>
              )}
            </div>
          </div>
        </Col>
        <Col
          xl={16}
          lg={16}
          md={24}
          sm={24}
          xs={24}
          className="block-image"
        ></Col>
      </Row>
    </div>
  );
};

export default withRouter(ResetPassword);
